import { createSelector } from 'reselect';
import { pathOr, identity } from 'ramda';

export const getEmailFromCodeCheck = createSelector(pathOr(null, ['bootData', 'user', 'email']), identity);
export const getUserData = createSelector(pathOr(null, ['bootData', 'user']), identity);
export const getIsValidUser = createSelector(pathOr(false, ['bootData', 'user', 'isValidUser']), identity);
export const getMyPermissions = createSelector(pathOr(null, ['bootData', 'permissions']), identity);
